<template>
  <Dialog :open="open" @close="$emit('close')" width="1024px">
    <template v-slot:title>
      <FlexRow justify="center" full-width>
        <Label text="テンプレートを編集します" size="h5" bold />
      </FlexRow>
    </template>
    <v-form ref="form">
      <FlexColumn>
        <FormItem name="テンプレート名" required>
          <TextField v-model="name" name="テンプレート名" :max="30" required/>
        </FormItem>
        <FormItem name="テンプレート内容" required>
          <TextArea
              v-model="detail"
              name="テンプレート内容"
              required
              ref="templateTextArea"
          />
            <FlexRow align="center">
              <Label text="変数の挿入: " class="mr-5"/>
              <Chip size="md" @click="handleClickVal('{{lastname}}')">
                <Label text="候補者 姓"/>
              </Chip>
              <Chip size="md" @click="handleClickVal('{{firstname}}')">
                <Label text="候補者 名"/>
              </Chip>
              <Chip size="md" @click="handleClickVal('{{job}}')">
                <Label text="求人名"/>
              </Chip>
            </FlexRow>
        </FormItem>
        <FlexRow justify="center">
          <Button outlined @click="$emit('close')">キャンセル</Button>
          <Button color="primary" @click="handleSubmit">保存</Button>
        </FlexRow>
      </FlexColumn>
    </v-form>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import FlexRow from "../atoms/FlexRow";
import Label from "../atoms/Label";
import FlexColumn from "../atoms/FlexColumn";
import FormItem from "../molecules/FormItem";
import TextField from "../atoms/TextField";
import Chip from "../atoms/Chip";
import Button from "../atoms/Button";
import ApiMixin from "../../ApiMixin";
import TextArea from "../atoms/TextArea";
export default {
  name: "MessageTemplateEditDialog",
  mixins: [ApiMixin],
  components: {TextArea, Button, Chip, TextField, FormItem, FlexColumn, Label, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean
    },
    template: {
      type: Object
    },
    companyId: {
      type: String
    }
  },
  data() {
    return {
      name: "",
      detail: ""
    }
  },
  methods: {
    async handleSubmit() {
      if (this.$refs.form.validate()) {
        await this.saveMessageTemplate(this.companyId, this.template.id, this.name, this.detail)
        this.$emit("close")
      }
    },
    handleClickVal(value) {
      this.$refs.templateTextArea.insertText(value)
    }
  },
  watch: {
    template: {
      handler(value) {
        if (value) {
          this.name = value.name
          this.detail = value.detail
        }
      },
    }
  }
}
</script>

<style scoped>

</style>